import React from 'react'

import type { FullTimeDetails, InternshipDetails, JobOffer } from '../../../api/job-offers/types'
import ClickableCard from '../../components/layout/ClickableCard'
import JobOfferCard from '../../components/job-offers/Card'
import JobOfferDetails from '../../components/job-offers/Details'
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg?react'

type Props = {
  jobOffer: JobOffer,
  jobOfferOpened?: JobOffer,
  onClick: (jobId: number) => void,
  isOpened: boolean,
  isLoading: boolean,
  applied?: boolean,
  engaged?: boolean,
}
const JobCard: React.FC<Props> = ({ jobOffer, jobOfferOpened, onClick, isOpened, isLoading, applied, engaged }) => {
  return (
    <ClickableCard>
      <div onClick={() => onClick(jobOffer.id)} className='group relative sm:pb-0'>
        <JobOfferCard
          title={jobOffer.title}
          company={{ logoSrc: jobOffer.company.logoSrc ?? '', name: jobOffer.company.name ?? '' }}
          city={jobOffer.city?.name}
          workTypes={jobOffer.workTypes?.map((wt) => wt.name).join(', ')}
          workShift={jobOffer.workShiftType?.name}
          salary={(jobOffer.details)?.salary}
          experience={(jobOffer.details as FullTimeDetails)?.experience}
          startDateInfo={jobOffer.startDateInfo}
          isCurricular={(jobOffer.details as InternshipDetails)?.isCurricular}
          isInternship={jobOffer.isInternship}
          isRecruitingEvent={jobOffer.isRecruitingEvent}
          lastPublishedAt={jobOffer.lastPublishedAt}
          isOpened={isOpened}
          applied={applied}
          engaged={engaged}
          isInternal={!jobOffer.isExternal}
        />
        <div className={`${isOpened ? 'flex rotate-180' : 'hidden sm:group-hover:flex'} absolute items-center justify-center w-full bottom-2`}>
          <ChevronDownIcon />
        </div>
      </div>
      {isOpened && (
        <JobOfferDetails
          id={jobOffer.id}
          isLoading={isLoading}
          description={jobOfferOpened?.description}
          requirements={jobOfferOpened?.requirements}
          externalLink={jobOfferOpened?.externalLink}
          careerPaths={jobOfferOpened?.careerPaths}
          sector={jobOfferOpened?.company.industry?.sector?.name}
          isInternship={jobOfferOpened?.isInternship}
          isRecruitingEvent={jobOfferOpened?.isRecruitingEvent}
          duration={(jobOfferOpened?.details as InternshipDetails)?.duration}
          hasAgreement={(jobOffer.details as InternshipDetails)?.hasAgreement}
          dateLimitInfo={jobOfferOpened?.applyDateLimit}
          contactPerson={jobOfferOpened?.contactPerson}
          resources={jobOfferOpened?.resources}
          companyId={jobOfferOpened?.company.id}
          divisionId={jobOfferOpened?.divisionId}
          subDivisionId={jobOfferOpened?.subDivisionId}
          isExternal={jobOffer.isExternal}
          applied={applied}
        />
      )}
    </ClickableCard>
  )
}

export default JobCard
